module.exports = __webpack_public_path__ + "img/mobile_banner_interactiveView.d3368541.png";